import type { CardProps } from 'src/notifications/cardTypes';
import { formatShortDate } from 'src/utils/dateFormatting';
import DocumentActions from '../DocumentActions';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';

export default function MeetingAgendaCompleteCard({
  notification,
  payload,
  onClose,
}: CardProps<'MEETING_AGENDA_COMPLETE'>) {
  const failed = payload.status === 'FAILED';
  const editPath = `/client/${payload.client_id}/document/meeting-agendas/${payload.meeting_agenda_id}/edit`;

  return (
    <NotificationCardShell
      notification={notification}
      title={failed ? 'Meeting agenda failed' : 'Meeting agenda ready'}
      body={
        failed
          ? 'Your meeting agenda could not be generated.'
          : 'Your meeting agenda has been generated.'
      }
      clientId={payload.client_id}
      details={
        payload.meeting_date ? (
          <NotificationDetailRow
            label="Meeting date"
            value={formatShortDate(payload.meeting_date)}
          />
        ) : undefined
      }
      actions={
        <>
          <NotificationLinkButton
            primary
            to={`/client/${payload.client_id}/document/meeting-agendas`}
            onClose={onClose}
          >
            View
          </NotificationLinkButton>
          {!failed && payload.meeting_agenda_id && (
            <DocumentActions
              clientId={payload.client_id}
              documentId={payload.meeting_agenda_id}
              fileId={payload.file_id}
              editPath={editPath}
              email={{ type: 'MEETING_AGENDA', label: 'Meeting agenda' }}
              onClose={onClose}
            />
          )}
        </>
      }
    />
  );
}
